import React from 'react';
import { Icon } from '@fluentui/react';
import { observer } from 'mobx-react';
import { EntityDashboardListItemState } from '../../state/EntityDashboardState';

interface EntityItemFavouriteButtonProps {
	state: EntityDashboardListItemState;
	onToggle: () => void;
}

class EntityItemFavouriteButton extends React.Component<EntityItemFavouriteButtonProps> {
	render() {
		const { state, onToggle } = this.props;
		return (
			<div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
				<Icon
					iconName={state.isFavorited ? 'FavoriteStarFill' : 'FavoriteStar'}
					title={state.isFavorited ? 'Pinned' : 'Not pinned'}
					style={{
						cursor: 'pointer',
						fontSize: 18,
						color: state.isFavorited ? '#FFB900' : undefined,
					}}
					onClick={onToggle}
				/>
			</div>
		);
	}
}

export default observer(EntityItemFavouriteButton);
